const LoadingTimeout = 10 * 1000;

function getScriptInternal(source, resolve, reject) {
  let script = document.createElement('script');
  const prior = document.getElementsByTagName('script')[0];
  script.async = 1;
  prior.parentNode.insertBefore(script, prior);

  let loaded = false;

  script.onload = script.onreadystatechange = function (_, isAbort) {
    if (
      isAbort ||
      !script.readyState ||
      /loaded|complete/.test(script.readyState)
    ) {
      script.onload = script.onreadystatechange = null;
      script = undefined;

      if (!isAbort && resolve) {
        loaded = true;
        resolve();
      }
    }
  };

  script.src = source;

  setTimeout(() => {
    if (!loaded && reject) {
      reject();
    }
  }, LoadingTimeout);
}

export function getScript(source) {
  return new Promise((resolve, reject) => {
    getScriptInternal(source, resolve, reject);
  });
}
